export default __webpack_public_path__ + "78800ea4.svg";